import { render, staticRenderFns } from "./DialogEventForm.vue?vue&type=template&id=b6c1fb1e&scoped=true"
import script from "./DialogEventForm.js?vue&type=script&lang=js&external"
export * from "./DialogEventForm.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c1fb1e",
  null
  
)

export default component.exports